import { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import Modal from "react-modal";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";

const MediaRegistrationList = (props) => {
  const [serviceId, setServiceId] = useState("none");
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 30,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };
  const { addForm, update, sId } = props;
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        // console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);

  const { sendRequest: getMediaRegistration } = useHttp();

  const getData = () => {
    getMediaRegistration(
      {
        url: `/api/mediaRegistration/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        console.log("API response:", res);
        if (res && Array.isArray(res.mediaRegistrationList)) {
          setData(res.mediaRegistrationList);
          setAllData(res.mediaRegistrationList);
        } else {
          setData([]);
          setAllData([]);
        }
      }
    );
  };

  useEffect(() => {
    getData();
  }, []);

  const { sendRequest: entryDelete } = useHttp();

  const handleDelete = (e, mediaRegistrationId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content:
        "Are you sure you want to delete this farmer input template detail?",
      onOk() {
        const data = {
          mediaRegistrationId: mediaRegistrationId,
          serviceId: sId,
        };
        //console.log(data);

        entryDelete(
          {
            url: "/api/mediaRegistration/",
            method: "DELETE",
            body: data,
          },
          (data) => {
            toast.success("Data deleted successfully");
            getDetailView();
          }
        );
      },
      onCancel() {},
    });
  };

  const handleSearch = (e) => {
    var filtertext = e.target.value.trim().toLowerCase();
    //console.log(filetrtext);

    var filterdata = allData.filter(
      (item) =>
        item.templateDate.toLowerCase().includes(filtertext) ||
        item.docNo.toLowerCase().includes(filtertext) ||
        item.templateName.toLowerCase().includes(filtertext) ||
        item.cropName.toLowerCase().includes(filtertext) ||
        item.employeeName.toLowerCase().includes(filtertext)
    );

    setData(filterdata);

    setCurrentPage(1);
  };

  const { sendRequest: getDetailView } = useHttp();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    const mediaRegistrationId = data?.mediaRegistrationId;

    getDetailView(
      {
        url: `/api/mediaRegistration/?orgId=${localStorage.getItem(
          "orgId"
        )}&mediaRegistrationId=${mediaRegistrationId}`,
      },
      (res) => {
        console.log("Detail View", res);

        // const details = res?.mediaRegistrationList?.[0];
        const details = res?.mediaRegistrationList?.find(
          (item) => item.mediaRegistrationId === mediaRegistrationId
        );

        if (details) {
          const transformed = {
            ...details,
            employeeName: `${details.employeeName}`, // You can replace this with a real name lookup
            mediaRegistrationProductDetails:
              details.mediaRegistrationProductDetails.map((prod) => ({
                ...prod,
                productSubTypeName: `${prod.productSubTypeName}`, // Placeholder unless you have this
                unitAbbreviation: `${prod.unitName}`, // Placeholder unless you have this
              })),
          };

          setSelectedData(transformed);
        } else {
          setSelectedData(null);
        }
      }
    );

    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const [selectedApprovalData, setSelectedApprovalData] = useState(null);
  const [approvalPopupVisible, setApprovalPopupVisible] = useState(false);

  const [remark, setRemark] = useState("");

  const { sendRequest: updateApprovalStatus } = useHttp();

  const showApprovalPopup = (expense) => {
    console.log(expense);
    setSelectedApprovalData(expense);
    setApprovalPopupVisible(true);
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };

  const handleApprovalSubmit = (status) => {
    const approvalStatus = status || "";
    // console.log(approvalStatus);
    let data = "";
    if (approvalStatus === "approve") {
      data = {
        mediaRegistrationId:
          selectedApprovalData && selectedApprovalData.mediaRegistrationId,
        approved: 1,
        approvedBy: parseInt(localStorage.getItem("empId")),
        serviceId: serviceId,
        nextlevel: 0,
        orgId: localStorage.getItem("orgId"),
        reamrk: remark,
      };
    } else if (approvalStatus === "disapprove") {
      data = {
        mediaRegistrationId:
          selectedApprovalData && selectedApprovalData.mediaRegistrationId,
        approved: 2,
        approvedBy: parseInt(localStorage.getItem("empId")),
        serviceId: serviceId,
        nextlevel: 0,
        orgId: localStorage.getItem("orgId"),
        reamrk: remark,
      };
    } else if (approvalStatus === "sendNextApprove") {
      data = {
        mediaRegistrationId:
          selectedApprovalData && selectedApprovalData.mediaRegistrationId,
        approved: 0,
        approvedBy: parseInt(localStorage.getItem("empId")),
        serviceId: serviceId,
        nextlevel: 1,
        orgId: localStorage.getItem("orgId"),
        reamrk: remark,
      };
    }

    // console.log(data);

    updateApprovalStatus(
      {
        url: "/api/mediaRegistrationapproval/",
        method: "PUT",
        body: data,
      },
      (data) => {
        toast.success(data);

        setApprovalPopupVisible(false);
        setRemark("");
        getData();
      }
    );
  };

  return (
    <>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        <div className="">
          <h3 className="card-title">Media Registration Details</h3>
          <div className="card-tools text-right">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={() => setIsModalOpen(false)}
            >
              <i className="fas fa-times" />
            </button>
            <hr />
          </div>
        </div>

        {selectedData && (
          <div className="mx-3">
            <div className="row">
              <p className="col-md-6">
                Media Registration Date : {selectedData.mediaRegistrationDate}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Media Name: {selectedData.mediaName}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Field Executive Name : {selectedData.employeeName}
              </p>
              <p className="col-md-6">Quantity : {selectedData.quantity}</p>
            </div>
            <div className="row">
              <p className="col-md-6">Lifespan : {selectedData.lifespan}</p>
              <p className="col-md-6">
                Description : {selectedData.description}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">Unit: {selectedData.unitName}</p>
            </div>

            <h5 className="card-title">Product Details</h5>
            <table className="table table-bordered text-center">
              <thead>
                <tr className="tableheaderrowview">
                  <th>Sr. No</th>
                  <th>Product SubType</th>
                  <th>Product Name</th>
                  <th>Quantity</th>
                  <th>Unit</th>
                </tr>
              </thead>
              <tbody>
                {selectedData.mediaRegistrationProductDetails &&
                  selectedData.mediaRegistrationProductDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{itm.productSubTypeName}</td>
                        <td>{itm.productName}</td>
                        <td>{itm.quantity}</td>
                        <td>{itm.unitAbbreviation}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}
      </Modal>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">Media Registration</label>
          </div>

          <div className="col-6 text-right">
            <button
              type="button"
              className="btn  btn-primary mx-3 my-3"
              onClick={() => {
                addForm(true);
                sId(serviceId);
                props.update(false);
              }}
            >
              Add Media Registration
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-5"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />{" "}
                      </div>
                    </div>
                    <br />
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>Date</th>
                          {/* <th>Request No</th> */}
                          <th>Media Name</th>
                          <th>Executive Name</th>
                          <th>Approve</th>
                          <th>Approved by</th>
                          <th>View</th>
                          <th>Edit</th>
                          <th>Delete</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems && currentItems.length > 0 ? (
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.mediaRegistrationDate}</td>
                                {/* <td>{i + 1}</td> */}
                                <td>{itm.mediaName}</td>
                                <td>{itm.employeeName}</td>{" "}
                                <td>
                                  <button
                                    className="btn"
                                    type="button"
                                    onClick={() => showApprovalPopup(itm)}
                                    disabled={
                                      itm.approved === 1 ||
                                      itm.approved === 2 ||
                                      itm.approved === 3
                                    }
                                  >
                                    {itm.approved == 1 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "green" }}
                                      ></i>
                                    ) : itm.approved == 2 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "red" }}
                                      ></i>
                                    ) : (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "gray" }}
                                      ></i>
                                    )}
                                  </button>
                                </td>
                                <td>{itm.approvedByName}</td>
                                <td>
                                  <button
                                    className="btn"
                                    // onClick={() => openModal(itm)}
                                    onClick={() => {
                                      openModal({
                                        ...itm,
                                        mediaRegistrationId:
                                          itm.mediaRegistrationId || itm.id,
                                      });
                                    }}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    onClick={() => {
                                      props.addForm(true);
                                      sId(itm.id || i);
                                      // props.update(itm);
                                      props.update({
                                        ...itm,
                                        mediaRegistrationId:
                                          itm.mediaRegistrationId || itm.id,
                                      });
                                    }}
                                    disabled={
                                      itm.approved === 1 ||
                                      itm.approved === 2 ||
                                      itm.approved === 3
                                    }
                                    className="btn"
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    // disabled={true}
                                    onClick={(e) =>
                                      handleDelete(e, itm.mediaRegistrationId)
                                    }
                                    disabled={
                                      itm.approved === 1 ||
                                      itm.approved === 2 ||
                                      itm.approved === 3
                                    }
                                    className="btn"
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="9">No data found</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <AntModal
        title="Farmer Input Template Approval"
        open={approvalPopupVisible}
        onCancel={() => setApprovalPopupVisible(false)}
        footer={null}
      >
        <label>Remarks:</label>
        <textarea
          rows={3}
          value={remark}
          className="form-control"
          onChange={handleRemarkChange}
        />
        <br />
        <div>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => {
              handleApprovalSubmit("approve");
            }}
          >
            Approve
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            onClick={() => {
              handleApprovalSubmit("disapprove");
            }}
            className="btn btn-sm btn-primary"
          >
            Disapprove
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => {
              handleApprovalSubmit("sendNextApprove");
            }}
          >
            Send Next Approve
          </button>
        </div>
      </AntModal>
    </>
  );
};

export default MediaRegistrationList;
